import React, { Fragment, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import Message from 'app/components/_ui/Message';
import { logout as logoutAction } from 'app/common/actions/user';
import Documents from 'app/common/components/Documents';
import EmailChangeMaterial from 'app/common/components/Profile/EmailChange/EmailChangeMaterial';


const enhance = connect(null, dispatch => ({
  logout: (e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    dispatch(logoutAction());
  },
}));

/**
 *  Обязательный e-mail
 */

export const RsnEmail = enhance(({ logout }) => {
  const [modalDisplayed, setModalDisplayed] = useState(false);

  const open = useCallback(() => setModalDisplayed(true), []);
  const close = useCallback(() => setModalDisplayed(false), []);

  return (
    <Fragment>
      {!modalDisplayed
        && <Message
          text={'Для того чтобы продолжить работу,\nнеобходимо указать e-mail в вашем профиле'}
          buttons={[
            {
              href: '',
              onClick: logout,
              value: 'Выйти',
              outline: true,
              key: 'logout',
            }, {
              href: '',
              onClick: open,
              value: 'Указать e-mail',
              key: 'change',
            },
          ]}
        />}
      {modalDisplayed
        && <EmailChangeMaterial close={close} />}
    </Fragment>
  );
});

export const isRsnEmail = createSelector(
  [
    state => state.user,
  ],
  user => (
    !!(user.result === 'success' && !user.email && user.code_to_mail)
  )
);


/**
/* Принятие договоров оферты и обработки личных данных
*/

export const RsnDocument = Documents;

export const isRsnDocument = createSelector(
  [
    state => state.documents,
    state => (state.documents.result === 'success' && state.user.result === 'success'),
    state => !!state.user.student,
  ],
  (documents, isLoadSuccess, isStudent) => ((isLoadSuccess && !isStudent)
    ? !!Object.keys(documents).find(key => !documents[key].accepted)
    : false)
);
